module.exports = __webpack_public_path__ + "static/media/WoltProviderLogo.38dc4316.png";